(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["schoko-organic-hero"] && !Shopify.designMode) return;
  try {
    
  class SchokoOrganicHeroSlider {
    constructor(section) {
      this.section = section;
      this.slides = Array.from(section.querySelectorAll('.schoko-organic-hero__slide'));
      this.dots = Array.from(section.querySelectorAll('.schoko-organic-hero__dot'));
      this.prevButton = section.querySelector('.schoko-organic-hero__arrow--prev');
      this.nextButton = section.querySelector('.schoko-organic-hero__arrow--next');
      this.index = 0;
      this.timer = null;
      this.autoplay = section.dataset.autoplay === 'true';
      this.speed = Number(getComputedStyle(section).getPropertyValue('--schoko-autoplay-speed').replace('ms', '').trim()) || 7000;

      if (this.slides.length <= 1) {
        return;
      }

      this.bindEvents();

      if (this.autoplay) {
        this.startAutoplay();
      }
    }

    bindEvents() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.goTo(this.index - 1);
          this.restartAutoplay();
        });
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.goTo(this.index + 1);
          this.restartAutoplay();
        });
      }

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const target = Number(dot.dataset.slideTarget);
          this.goTo(target);
          this.restartAutoplay();
        });
      });

      this.section.addEventListener('mouseenter', () => {
        this.stopAutoplay();
      });

      this.section.addEventListener('mouseleave', () => {
        this.startAutoplay();
      });
    }

    goTo(nextIndex) {
      const max = this.slides.length - 1;

      if (nextIndex < 0) {
        nextIndex = max;
      }

      if (nextIndex > max) {
        nextIndex = 0;
      }

      this.slides[this.index].classList.remove('is-active');

      if (this.dots[this.index]) {
        this.dots[this.index].classList.remove('is-active');
      }

      this.index = nextIndex;

      this.slides[this.index].classList.add('is-active');

      if (this.dots[this.index]) {
        this.dots[this.index].classList.add('is-active');
      }
    }

    startAutoplay() {
      if (!this.autoplay || this.slides.length <= 1 || this.timer) {
        return;
      }

      this.timer = window.setInterval(() => {
        this.goTo(this.index + 1);
      }, this.speed);
    }

    stopAutoplay() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  document.querySelectorAll('.schoko-organic-hero').forEach((section) => {
    new SchokoOrganicHeroSlider(section);
  });

  } catch(e) { console.error(e); }
})();
})();
